import { BoxProps } from '@chakra-ui/react';
import { Text } from 'components/UI';

const SettingsFieldDescription = (props: BoxProps) => <Text as="small" w="full" {...props} />;

export default SettingsFieldDescription;
